export const SkeletonBar = ({ className = "", style }) => (
  <div className={`skeleton-shimmer-bar rounded ${className}`} style={style} />
);
